var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.737305,
    y: 6.1875,
    width: 4.13534,
    height: 4.125,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22527 10.1906H4.27527V10.1406V6.77464V6.72464H4.22527H0.859375H0.809375V6.77464V10.1406V10.1906H0.859375H4.22527ZM5.54287 1.23892L5.5 1.16746L5.45713 1.23892L3.68088 4.1994L3.63545 4.27512H3.72376H7.27624H7.36455L7.31912 4.1994L5.54287 1.23892ZM0.429688 5.96525H4.65496C4.86464 5.96525 5.03464 6.13524 5.03464 6.34495V10.5703C5.03464 10.78 4.86466 10.95 4.65496 10.95H0.429688C0.219986 10.95 0.05 10.78 0.05 10.5703V6.34495C0.05 6.13524 0.219986 5.96525 0.429688 5.96525ZM5.96538 8.45763C5.96538 7.08336 7.08347 5.96525 8.45769 5.96525C9.83191 5.96525 10.95 7.08336 10.95 8.45763C10.95 9.83189 9.83193 10.95 8.45769 10.95C7.08347 10.95 5.96538 9.83189 5.96538 8.45763ZM6.72475 8.45763C6.72475 9.41324 7.5021 10.1906 8.45769 10.1906C9.41328 10.1906 10.1906 9.41324 10.1906 8.45763C10.1906 7.50203 9.41328 6.72464 8.45769 6.72464C7.5021 6.72464 6.72475 7.50203 6.72475 8.45763ZM8.03516 5.03452H2.96484C2.6702 5.03452 2.48762 4.7122 2.63926 4.45946L5.17442 0.234107C5.3219 -0.0116979 5.67849 -0.0110396 5.82558 0.234106L8.36074 4.45946C8.51233 4.71213 8.32989 5.03452 8.03516 5.03452Z",
    fill: "#1C1C1C",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommo);
export default __webpack_public_path__ + "static/media/commo.6593a40b7a01168a95b3a98bf0b49f00.svg";
export { ForwardRef as ReactComponent };